// extracted by mini-css-extract-plugin
export default {"wrapper":"logoDesktop_wrapper__wTI+s","line":"logoDesktop_line__d1iH4","line2":"logoDesktop_line2__cpTna"};